import { render, staticRenderFns } from "./PhotosWidget.vue?vue&type=template&id=752b0781&"
import script from "./PhotosWidget.vue?vue&type=script&lang=js&"
export * from "./PhotosWidget.vue?vue&type=script&lang=js&"
import style0 from "./PhotosWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports